import { Fragment, useMemo } from 'react';
import { RepresentativesListSkeleton } from './components/Skeletons/RepresentativesListSkeleton';
import { useRepresentativesListAction } from './hooks/useRepresentativesListAction';
import { useRepresentativesContext } from 'pages/Representatives/context/RepresentativesProvider';
import { array_skeletons } from 'pages/Representatives/const/array_skeleton';
import RepresentativesListItem from './components/RepresentativesListItem/RepresentativesListItem';

const RepresentativesList = () => {
  // Getting the Representatives Profile
  const { profiles, isLoading, isFetching } = useRepresentativesContext();

  // Getting the current primary id
  const currentPrimaryId = profiles?.find((profile) => profile?.primary)?.id || '';

  // The Representatives Profile List
  const multipleProfiles = useMemo(() => (profiles ? profiles : []), [profiles?.length, currentPrimaryId]);

  // Getting the Representatives Actions
  const { handlePrimaryChange, handleMakePrimaryLoading, currentProgressId } = useRepresentativesListAction({
    currentPrimaryId,
  });

  return (
    <Fragment>
      {isLoading || (!multipleProfiles && isFetching && !handleMakePrimaryLoading)
        ? array_skeletons.map((_, index) => <RepresentativesListSkeleton key={index} />)
        : multipleProfiles?.map((profile) => (
            <RepresentativesListItem
              profile={profile}
              key={profile.id}
              handlePrimaryChange={handlePrimaryChange}
              primaryTagLoading={currentProgressId === profile?.id && handleMakePrimaryLoading}
              primaryTagDisable={handleMakePrimaryLoading}
            />
          ))}
    </Fragment>
  );
};

export default RepresentativesList;
